<script setup>
import { ref, onMounted } from 'vue';
import IMask from 'imask';

const props = defineProps({
  id: String,
  label: String,
  ariaLabel: String,
  name: String,
  readonly: Boolean,
  disabled: Boolean,
  size: String,
  required: Boolean,
  error: String,
  modelValue: String,
  placeholder: String, // also defines mask for 'tel' type
  title: String,
  maxlength: String,
  type: {
    type: String,
    default: 'text',
  },
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
  if (props.type === 'tel') {
    IMask(input.value, { mask: props.placeholder });
  }

  if (props.type === 'zip') {
    IMask(input.value, {
      mask: /^[\da-zA-Z- ]+$/,
    });
  }
});
</script>

<template>
<div class="text-input mb-[15px]" :title="title">
  <label class="block text-[14px]">
    <span
      class="
        text-black
        flex
        justify-between
        mb-[5px]
        font-FordAntennaMed
        tablet:font-FordAntennaLight
      ">
      <div>
        {{ label }}
        <sup class="text-red-500" v-if="required">*</sup>
      </div>
      <div v-if="required">
        {{ error }}
      </div>
    </span>
    <input
      ref="input"
      class="border border-[#707070] py-[12px] px-[14px] leading-[14px] w-full"
      @input="$emit('update:modelValue', $event.target.value)"
      :type="['zip', 'tel'].includes(type) ? 'text' : type"
      :aria-label="ariaLabel"
      :id="id"
      :name="name"
      :value="modelValue"
      :size="size"
      :disabled="disabled"
      :readonly="readonly"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :required="required"
    />
  </label>
</div>
</template>
